import { BigRing } from '../components/BigRing'
import type { Exercise, LevelMeta, RuleKey } from '../logic/types'

interface Props {
  level: LevelMeta
  total: number
  goodCount: number
  badCount: number
  wrongIds: string[]
  exercisesById: Map<string, Exercise>
  rules: Record<RuleKey, { title: string; ru: string }>
  onAgain: () => void
  onHome: () => void
}

export function Result({
  total,
  goodCount,
  badCount,
  wrongIds,
  exercisesById,
  rules,
  onAgain,
  onHome,
}: Props) {
  const pct = total > 0 ? goodCount / total : 0
  const title = pct === 1 ? 'Uitstekend!' : pct >= 0.7 ? 'Goed gedaan!' : 'Komt goed!'
  const sub =
    `${goodCount} из ${total} верно. ` +
    (badCount > 0
      ? 'Ошибки останутся в пуле и попадутся снова.'
      : 'Все ответы сохранены — эти фразы больше не появятся.')

  return (
    <section className="screen active" id="scr-result">
      <div className="center-wrap" style={{ justifyContent: 'flex-start', paddingTop: 56 }}>
        <BigRing fraction={pct} top={pct === 1} />
        <h2 className="res-title">{title}</h2>
        <div className="res-sub">{sub}</div>
        {badCount > 0 && (
          <div className="mist-list">
            {wrongIds.map((id) => {
              const e = exercisesById.get(id)
              if (!e) return null
              const r = rules[e.rule]
              const correctForm = e.forms[e.answer]
              return (
                <div className="mist" key={id}>
                  <div className="s">
                    {e.text.split('___').map((part, i, arr) => (
                      <span key={i}>
                        {part}
                        {i < arr.length - 1 && <b>{correctForm}</b>}
                      </span>
                    ))}
                  </div>
                  <div className="r">{r.ru}</div>
                </div>
              )
            })}
          </div>
        )}
      </div>
      <div className="bottom-cta">
        <button className="btn primary" onClick={onAgain}>Nog een ronde</button>
        <button className="btn ghost" onClick={onHome}>Naar het overzicht</button>
      </div>
    </section>
  )
}
